/**
 * Adds a listener to a view's hook whatever shape the owner gave it: a listener list (array or `{ add }`), or a single
 * `((...) => void) | null` slot, which is chained so an earlier subscriber (look's dusk, ui's boss bar) keeps working.
 */
export function listen<A extends unknown[]>(host: object, key: string, fn: (...args: A) => void): void {
  const h = host as Record<string, unknown>;
  const cur = h[key];
  if (Array.isArray(cur)) { cur.push(fn); return; }
  if (cur !== null && typeof cur === "object" && typeof (cur as { add?: unknown }).add === "function") { (cur as { add: (f: unknown) => void }).add(fn); return; }
  const prev = typeof cur === "function" ? (cur as (...args: A) => void) : null;
  h[key] = (...args: A) => { prev?.(...args); fn(...args); };
}
